import { EnumModel, EnumRecord } from "core/models/enum.model";

export interface PaymentTypeEnumModel extends EnumModel {
  value: number;
}

export enum PaymentTypeEnum {
  Online = 1,
  BankBranch = 2,
  POS = 3,
}

export const PaymentType: EnumRecord<PaymentTypeEnum, PaymentTypeEnumModel> = {
  [PaymentTypeEnum.Online]: { value: 1, description: "درگاه اینترنتی" },
  [PaymentTypeEnum.BankBranch]: { value: 2, description: "شعبات بانک کشاورزی" },
  [PaymentTypeEnum.POS]: { value: 3, description: "دستگاه کارتخوان" },
};
